<!--Echarts重封装-->
<!--折线图-->
<template>
  <div>
    <!--  折线图和最大最小值-->
    <div class="echartContent" v-loading="loading" id="echart2"></div>
    <el-descriptions
      class="border "
      :column="3"
      style="padding: 5px"
      v-if="minMax"
    >
      <el-descriptions-item :label="$t('integration.maximum')"
        >{{ formatTempValue(minMax.max, customUnit[this.probe]) }}{{ customUnit[this.probe] }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('integration.minimum_value')"
        >{{ formatTempValue(minMax.min, customUnit[this.probe]) }}{{ customUnit[this.probe] }}
      </el-descriptions-item>
      <el-descriptions-item :label="$t('integration.average_value')"
        >{{ formatTempValue(minMax.avg, customUnit[this.probe]) }}{{ customUnit[this.probe] }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import {
  chartOptions,
  seriesItem
} from '@/components/Charts/schema/LineChartSchema'
import { markStore } from '@/utils/echart'
import { defaultUnit } from '@/utils/convert'

export default {
  computed: {
    defaultUnit () {
      return defaultUnit
    }
  },
  props: {
    request: {
      // ()=>Promise<ChartData>
      type: Function
    },
    probe: {
      type: String,
      default: 'temp'
    },
    range: {
      // {max:1  min:1}
      type: Object,
      default: () => ({})
    },
    minMax: {
      type: Object
    },
    customUnit:{
      type: Object
    }
  },
  data () {
    return {
      resizeTimer: null,
      loading: false,
      echartInstance: false,
      minValue: null,
      maxValue: null,
      // 监测区间最大最小值
      rangeMin: null,
      rangeMax: null,
      chartOption: null
    }
  },

  mounted () {
    this.refresh()
  },
  methods: {
    formatTempValue(val,code) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'
      const result = TempUtils.convertToCelsius(numVal, code)
      const finalVal = isNaN(result) ? '--' : Number(result).toFixed(2)
      return `${finalVal}`
    },
    render () {
      this.isRenderChart = true

      this.iDisplayStart = 0
      this.sampleHash = {}
      this.getListFn()
    },
    currentChange ({ iDisplayStart, iDisplayLength }) {
      this.SearchForm.iDisplayStart = iDisplayStart
      this.SearchForm.iDisplayLength = iDisplayLength
      this.getListFn()
    },
    rangeChange (item) {
      this.SearchForm.min = item.min
      this.SearchForm.max = item.max
    },
    /**
     * 刷新ecahrt图表
     * 会调用request重新请求
     */
    refresh () {
      let chartInstance
      let chartDom = null
      // 消除浏览器警告
      this.$nextTick(() => {
        // 因为在验证任务详情页面，单个设备的折线图表和数据对比弹框的图表id冲突，所以这个组件的id改成echart2
        this.$echarts.dispose(document.getElementById('echart2'))
        chartDom = document.getElementById('echart2')
        chartInstance = this.$echarts.init(chartDom)

        this.echartInstance = chartInstance

        // 浏览器适配
        window.addEventListener('resize', () => {
          if (this.resizeTimer) clearTimeout(this.resizeTimer)
          this.resizeTimer = setTimeout(() => {
            chartInstance.resize()
          }, 100)
        })
        chartInstance.resize()
      })

      if (!this.request) {
        return
      }
      this.loading = true

      this.request()
        /**
         * data 一维数组 单个series
         * datas 二维数组 多个series
         */
        .then(({ data }) => {
          if (data && data.length === 0) {
            chartDom.innerHTML = $t('public.no_data')
            chartDom.style.cssText =
              'text-align:center; color: #999; border: none;line-height: 300px'
            chartDom.removeAttribute('_echarts_instance_')
            return
          }

          // 监测区间  二位数组
          const markArea = []
          const series = seriesItem(this.probe)
          // 上一条数据的最大最小值 如果不相等 会创建一个新的区间
          let lastMin = null
          let lastMax = null

          // 折线图中监测区间的最大最小数字
          let valMax = Number.MIN_VALUE
          let valMin = Number.MAX_VALUE

          // 计算自定义区间
          if (this.range && this.range.min !== undefined) {
            markArea.push([
              {
                xAxis: 0,
                yAxis: this.range.min
              },
              {
                xAxis: data[data.length - 1].time,
                yAxis: this.range.max
              }
            ])
          }

          data.forEach((item, index) => {
            /**
             * 格式化Echarts数据
             */
            const time = this.$timetransition(item.time)
            series.data.push({
              value: [time, item.val],
              name: time,
              max: item.max,
              min: item.min,
              no: item.no
            })

            const min = item.min
            const max = item.max

            // 计算监测区间最大值和最小值
            if (min < valMin) {
              valMin = min
            }
            if (max > valMax) {
              valMax = max
            }

            if (
              (lastMin !== min ||
                lastMax !== max ||
                data.length === index + 1) &&
              this.range &&
              this.range.min === undefined
            ) {
              if (markArea[markArea.length - 1]) {
                // 有值 往最后一条尾部追加截止时间
                markArea[markArea.length - 1][1].xAxis = time
              }
              if (data.length !== index + 1) {
                markArea.push([
                  {
                    xAxis: time,
                    yAxis: min
                  },
                  {
                    xAxis: time,
                    yAxis: max
                  }
                ])
              }
            }

            lastMax = max
            lastMin = min
          })

          /**
           * 设置监测区间
           */
          series.markArea.data = markArea
          this.rangeMax = lastMax
          this.rangeMin = lastMin

          const chartOption = chartOptions({
            unit: this.customUnit[this.probe],
            valMin,
            valMax
          })
          // 计算store分段
          const pieces = markStore(data)
          chartOption.visualMap[0].pieces = pieces
          chartOption.series.push(series)
          chartInstance.setOption(chartOption, true)
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 获取监测区间
     */
    getRange () {
      return {
        min: this.rangeMin,
        max: this.rangeMax
      }
    },
    /**
     * 对外暴露
     * @param options
     */
    setOption (options) {
      console.log('setOption---------------------')
      if (this.echartInstance) {
        this.echartInstance.clear()

        this.chartOption = options

        this.echartInstance.setOption(options, true)
      }
    },
    /**
     * 对外暴露
     * @returns {null}
     */
    getOption () {
      return this.chartOption
    }
  }
}
</script>

<style lang="scss" scoped>
.echartContent {
  height: 300px;
  border: 1px solid #ccc;
  margin-bottom: 15px;
}
</style>
